'use strict';

/**
 * Change server data to list data.
 *
 * @param {Array} data - response from server
 *
 * @return {Array} prepared data for LayoutList
 */
module.exports = function ( data ) {
    var result = [],
        index;

    if ( data && data.length ) {
        for ( index = 0; index < data.length; index++ ) {
            result[index] = {
                items: [
                    {
                        className: 'theme-icon theme-icon-playlist'
                    },
                    {
                        className: 'title',
                        value: data[index].name
                    }
                ],
                value: data[index]
            };
        }
    }

    return result;
};
